import { render, staticRenderFns } from "./WithdrawWalletModal.vue?vue&type=template&id=2ac4283f&scoped=true"
import script from "./WithdrawWalletModal.vue?vue&type=script&lang=js"
export * from "./WithdrawWalletModal.vue?vue&type=script&lang=js"
import style0 from "./WithdrawWalletModal.vue?vue&type=style&index=0&id=2ac4283f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ac4283f",
  null
  
)

export default component.exports